import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdCreateSpamTestCacheKeys: AllRouteEndpoints[] = [];
export const engagementAppGroupIdCreateSpamTest = "/engagement/:app_group_id/create_spam_test";
